/**
 * @graphql agg
 */
import { gql } from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { getTrialDaysLeftFromTrialEndDate } from '@atlassian/upgrades-and-purchases/get-trial-days-left';

import {
	isErrorMarkedAsHandled,
	markErrorAsHandled,
} from '@confluence/graphql-error-processor/entry-points/GraphqlErrorProcessor.ts';

import type {
	useReverseTrialLozengeExperimentTrialDetailsQuery as useReverseTrialLozengeExperimentTrialDetailsQuery$data,
	useReverseTrialLozengeExperimentTrialDetailsQueryVariables as useReverseTrialLozengeExperimentTrialDetailsQuery$variables,
} from './__types__/useReverseTrialLozengeExperimentTrialDetailsQuery.ts';

export const useReverseTrialLozengeExperimentTrialDetails = (skip: boolean = false) => {
	const { data, error, loading } = useQuery<
		useReverseTrialLozengeExperimentTrialDetailsQuery$data,
		useReverseTrialLozengeExperimentTrialDetailsQuery$variables
	>(
		gql`
			query useReverseTrialLozengeExperimentTrialDetailsQuery {
				license {
					billingSourceSystem
					trialEndDate
				}
			}
		`,
		{
			fetchPolicy: 'cache-first',
			skip,
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	return {
		error,
		loading,
		daysLeft: getTrialDaysLeftFromTrialEndDate(data?.license?.trialEndDate) ?? null,
		billingSourceSystem: data?.license?.billingSourceSystem,
	};
};
